import { HomeContentView } from "components/materials/home/HomeContentView";

/**
 * Note that instructors and students share the same home view, just with slightly different controls.
 */
export default function Page() {
  return <HomeContentView userRole="instructor" />;
}
